// removed by extract-text-webpack-plugin
module.exports = {"miniChart":"app-2ZGA7Vs-","chartContent":"app-3eQYRRMn","chartLoading":"app-32FQcvur"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-components/charts/index.less
// module id = 230
// module chunks = 0